import { render, staticRenderFns } from "./BusinessmanIcon.vue?vue&type=template&id=7d684981&scoped=true"
import script from "./BusinessmanIcon.vue?vue&type=script&lang=js"
export * from "./BusinessmanIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d684981",
  null
  
)

export default component.exports